import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { SigninStrategyService } from '@shared/_services/signin-strategy.service';
import { ServerAuthService } from '@shared/_services/server-auth.service';
import { UserAuthService } from '@shared/_services/user-auth.service';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { getApiBaseUrl } from '@shared/_services/runtime-config';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  providers: [
    { provide: "API_BASE_URL", useValue: getApiBaseUrl() },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    AngularFireAuth,
    SigninStrategyService,
    ServerAuthService,
    UserAuthService,
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})
export class AuthComponent {
  returnUrl: string;
  loginForm?: FormGroup;
  termsAndConditionsUrl = environment.termsAndConditionsUrl;

  constructor(
    private router: Router,
    private authenticationSvc: UserAuthService,
    private signinStrategyService: SigninStrategyService,
    private userService: ServerAuthService,
    route: ActivatedRoute,
  ) {
    this.returnUrl = route.snapshot.queryParams['returnUrl'] || 'portal';
    console.log('API_BASE_URL', getApiBaseUrl());
    console.log('returnUrl', this.returnUrl);
    console.log('UserAuthService', this.authenticationSvc);
    console.log('UserAuthService', this.authenticationSvc.isLoggedIn);

    if (this.authenticationSvc.isLoggedIn) {
      console.log('User is already logged in', this.authenticationSvc);
      router.navigate([this.returnUrl]);
    }
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.email, Validators.required])),
      password: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  loginLocal(loginCreds: any) {
    const email = loginCreds.email.trim();
    const password = loginCreds.password.trim();

    this
      .signinStrategyService
      .signInFirebaseUserWithCreds({ email, password, returnUrl: this.returnUrl });
  }


  async loginGoogle() {

    console.log(this.returnUrl)

    const result: any = await this
      .signinStrategyService
      .AuthLogin();
    console.log('result', result)
    this.handleRedirect(result)
  }

  private handleRedirect(result: firebase.auth.IdTokenResult | any) {
    console.log(result.token);

    // @ts-ignore
    this.userService.signinFirebase(result.token)
      .subscribe((userModel: any) => {
        this.signinStrategyService.saveLoginAndNavigateToReturnUrl(userModel);
        window.location.href = this.returnUrl!;
      });
  }

  goToHome() {
    this.router.navigate([this.returnUrl]);
  }
}
